export class BrandIdentity {
	id: number
	name: string
	key: string
	createdAt: string
	updatedAt: string

	constructor(data: {
		id: number
		name: string
		key: string
		createdAt: string
		updatedAt: string
	}) {
		this.id = data.id
		this.name = data.name
		this.key = data.key
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
	}

	static create(data: Partial<BrandIdentity>): BrandIdentity {
		const defaultValues = {
			id: 0,
			name: '',
			key: '',
			createdAt: '',
			updatedAt: '',
		}

		return new BrandIdentity({ ...defaultValues, ...data })
	}
}
